import { ColDef, ValueFormatterParams } from 'ag-grid-community';
import { Colors } from 'routes/BudgetModule/config/constants';
import {
    JOB_LABEL,
    MANTY_STATUS,
    ORG_CHART_HR_NAME,
} from 'routes/HumanResourcesModule/business/definitions';
import { getAgentColumn } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/agentColumnHelpers';
import { DEFAULT_AMOUNT_COLUMN } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/defaultColDefs';
import {
    floatingFilter,
    getPositionValue,
} from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/gridHelpers';
import { currencyFormatter } from 'ui/AgGridReact/formatters';

const baseColDef = { ...floatingFilter, sortable: true, resizable: true };
const MIN_PERCENTAGE_THRESHOLD = 0.01;

export const getColDefs = (t: TranslationT): ColDef[] => [
    {
        ...getAgentColumn(),
        ...baseColDef,
        flex: 1,
    },
    {
        ...baseColDef,
        flex: 2,
        hide: true,
        field: MANTY_STATUS,
        headerName: t('humanResources.simulation.addAgent.mantyStatus'),
        valueGetter: (params) =>
            getPositionValue(params?.data?.mantyStatus ?? ''),
    },
    {
        ...baseColDef,
        flex: 2,
        field: ORG_CHART_HR_NAME,
        headerName: t('humanResources.simulation.addAgent.orgChartHr'),
    },
    {
        ...baseColDef,
        flex: 2,
        field: JOB_LABEL,
        headerName: t('humanResources.simulation.addAgent.jobLabel'),
    },

    {
        ...baseColDef,
        ...DEFAULT_AMOUNT_COLUMN,
        field: 'increasePercentage',
        headerName: t('humanResources.simulation.increasePercentage'),
        filterValueGetter: (params) =>
            (params?.data?.increasePercentage ?? 0) * 100,
        valueFormatter: (params) =>
            params?.data?.increasePercentage < MIN_PERCENTAGE_THRESHOLD
                ? '0,00..%'
                : `${((params?.data?.increasePercentage ?? 0) * 100).toFixed(2)}%`,
        cellRenderer: 'chipCellRenderer',
        cellRendererParams: {
            getColor: () => Colors.ORANGE,
            size: 'small',
        },
        sort: 'asc',
    },

    {
        ...baseColDef,
        ...DEFAULT_AMOUNT_COLUMN,
        field: 'smicIncreaseAmount',
        headerName: t('humanResources.simulation.increaseAmount'),
        valueGetter: (params) => {
            return params?.data?.smicIncreaseAmount ?? 0;
        },
        valueFormatter: (
            params: Partial<ValueFormatterParams>,
            forceSign?: boolean,
        ) => currencyFormatter(params, forceSign, false),
        aggFunc: 'sum',
    },
];
